export const CELL_METRICS = [
  {
    unitBefore: "$",
    label: "Merit award",
    value: "meritAward",
    isUserInput: true,
    min: 1,
  },
  {
    unitAfter: "%",
    label: "Need metric",
    value: "needMetric",
    isUserInput: true,
    max: 100,
    min: 1,
  },
  {
    unitBefore: "$",
    label: "Cap dollar",
    value: "capDollar",
    isUserInput: true,
    min: 1,
  },
  {
    unitAfter: "%",
    label: "Cap percent",
    value: "capPercent",
    isUserInput: true,
    max: 100,
    min: 1,
  },
  { label: "Admits", value: "Admits", isUserInput: false },
  { label: "Enrolls", value: "Enrolls", isUserInput: false },
];
